// src/components/compliance/StmUploadCard.jsx
// Thin wrapper — real implementation in shared/ui/FileDropzone.jsx.
import FileDropzone from "../../shared/ui/FileDropzone";
import { MAX_FILE_SIZE } from "../../utils/compliance/constants";

export default function StmUploadCard({ onSubmit }) {
  return (
    <FileDropzone
      theme="legacy"
      accept={[".docx", ".pdf"]}
      maxTotalSize={MAX_FILE_SIZE}
      title="Upload SOW document"
      description={
        <>
          Accepted formats: <strong>.docx</strong> or <strong>.pdf</strong>.
          The AI will analyse the SOW and extract every service, SLA, and staffing entry into a Service Traceability Matrix.
        </>
      }
      submitLabel="Generate Service Traceability Matrix"
      submittingLabel="Uploading…"
      onSubmit={onSubmit}
    />
  );
}
